// import React, { useEffect, useState } from "react";
// import styles from './tableComponent.module.css';
// import { Paginationleft, Paginationright } from "../../../../Svg";
// import { useDispatch } from "react-redux";
// import { getMatchedProductsThunk } from "../../../redux/bomSlice";
// import { useNavigate } from "react-router-dom";

// const TableComponent = ({ data, handleContinue, loading, selectedColumns, availableKeys, handleColumnChange }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 25;
//   const totalPages = Math.ceil(data?.length / itemsPerPage);
//   const navigate = useNavigate()

//   const currentItems = data?.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const goToPage = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const goToNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const goToPreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);



//   return (
//     <>
//       <div className={styles.previewContainer}>
//         <p>A preview of the upload is available below and columns have been mapped based on their contents. </p>

//         <div className={styles.previewContainerScroll}>
//           {/* <div className={styles.previewheader}>


//             {Object.keys(selectedColumns).map((col) => (
//               <select
//                 key={col}
//                 value={selectedColumns[col]}
//                 onChange={(e) => handleColumnChange(col, e.target.value)}
//                 className={styles.previewfilterDropdown}
//                 style={{ marginRight: "10%" }}
//               >
//                 <option value="" disabled>Select a column</option>
//                 {availableKeys.map((key) => (
//                   <option key={key} value={key}>
//                     {key}
//                   </option>
//                 ))}
//               </select>

//             ))}
//           </div> */}

//           <table className={styles.previewtable}>
//             {/* <thead>
//               <tr style={{background:'#222222'}}>
//                 <th  ></th>

//                 {Object.keys(selectedColumns).map((col) => (
//                   <th>
//                     <select
//                       key={col}
//                       value={selectedColumns[col]}
//                       onChange={(e) => handleColumnChange(col, e.target.value)}
//                       className={styles.previewfilterDropdown}
//                       style={{ margin: 14 }}
//                     >
//                       <option value="" disabled>Select a column</option>
//                       {availableKeys.map((key) => (
//                         <option key={key} value={key} >
//                           {key}
//                         </option>
//                       ))}
//                     </select>
//                   </th>

//                 ))}
//               </tr>
//               <tr>
//                 <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
//                 <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Mft Part #</th>
//                 <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Quantity</th>
//                 <th className={styles.previewth}>Manufacturer/Purchase Order #</th>
//               </tr>
//             </thead> */}
//             <thead>
//               <tr style={{ background: "#222222" }}>
//                 <th></th>
//                 {Object.keys(currentItems?.[0] || {})
//                   .filter((key) => key !== "id")
//                   .map((col) => (
//                     <th key={col}>
//                       <select
//                         value={selectedColumns[col] || ""}
//                         onChange={(e) => handleColumnChange(col, e.target.value)}
//                         className={styles.previewfilterDropdown}
//                         style={{ margin: 14 }}
//                       >
//                         <option value="">Select a column</option>
//                         <option value="productNumber">Product Number</option>
//                         <option value="quantity">Quantity</option>
//                         <option value="manufacturer">Manufacturer</option>
//                         <option value="skip">Skip</option>
//                       </select>
//                     </th>
//                   ))}

//               </tr>
//             </thead>

//             <tbody>
//               {currentItems?.map((item, index) => (
//                 <tr key={item.id} className={styles.previewstripedRow}>
//                   <td className={styles.previewtd}>{(currentPage - 1) * itemsPerPage + index + 1}</td>

//                   {Object.keys(item)
//                     .filter((key) => key !== "id" && selectedColumns[key] !== "skip")
//                     .map((key) => (
//                       <td key={key} className={styles.previewtd}>{item[key]}</td>
//                     ))}
//                 </tr>
//               ))}
//             </tbody>

//           </table>

//         </div>
//         <div className={styles.sortedPagination}>
//           <div className={styles.showingResults}>
//             Showing: <span>{(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, data?.length)}</span> of {data?.length}
//           </div>

//           <div className={styles.pagination}>
//             <button
//               onClick={goToPreviousPage}
//               disabled={currentPage === 1}
//               className={styles.paginationButton1}
//             >
//               <Paginationleft />
//             </button>

//             {pageNumbers.map((number) => (
//               <button
//                 key={number}
//                 onClick={() => goToPage(number)}
//                 className={`${styles.paginationButton} ${number === currentPage ? styles.active : ""}`}
//               >
//                 {number}
//               </button>
//             ))}

//             <button
//               onClick={goToNextPage}
//               disabled={currentPage === totalPages}
//               className={styles.paginationButton1}
//             >
//               <Paginationright />
//             </button>
//           </div>
//         </div>

//         <div className={styles.displayFlex}>
//           <button className={styles.cancelBtn} onClick={() => navigate(-1)}>Back</button>
//           <button className={styles.submitBtn} onClick={handleContinue} disabled={loading}>{loading ? 'please wait' : 'Continue'}</button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TableComponent;
import React from "react";
import styles from './tableComponent.module.css';
import { Paginationleft, Paginationright } from "../../../../Svg";
import { useNavigate } from "react-router-dom";

const TableComponent = ({
  data,
  handleContinue,
  loading,
  selectedColumns,
  handleColumnChange,
  columnConflict
}) => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 25;
  const totalPages = Math.ceil(data?.length / itemsPerPage);
  const navigate = useNavigate();

  const columnNames = React.useMemo(() => {
    const columns = new Set();
    data.forEach(row => {
      Object.keys(row).forEach(key => {
        if (key !== 'id') columns.add(key);
      });
    });
    return Array.from(columns).sort((a, b) =>
      parseInt(a.replace('column', '')) - parseInt(b.replace('column', ''))
    );
  }, [data]);

  const currentItems = data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const getAvailableOptions = () => [
    { value: "productNumber", label: "Product Number" },
    { value: "quantity", label: "Quantity" },
    { value: "manufacturer", label: "Manufacturer" },
    { value: "skip", label: "Skip this column" }
  ];


  const goToPage = (pageNumber) => setCurrentPage(pageNumber);
  const goToNextPage = () => currentPage < totalPages && setCurrentPage(currentPage + 1);
  const goToPreviousPage = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <>
      <div className={styles.previewContainer}>
        <p>A preview of the upload is available below. Please map the columns to the appropriate fields.</p>
        {Object.values(columnConflict).some(Boolean) && (
          <div className={styles.errorMessage}>
            Error: You cannot map the same field to multiple columns. Please resolve conflicts.
          </div>
        )}

        <div className={styles.previewContainerScroll}>
          <table className={styles.previewtable}>
            <thead>
              <tr style={{ background: "#222222", color: "white" }}>
                <th style={{ width: "50px" }}>#</th>
                {columnNames.map((col) => (
                  <th key={col} className={columnConflict[col] ? styles.conflictColumn : ""}>
                    <div className={styles.columnHeader}>
                      {/* <div className={styles.columnName}>Column {col.replace('column', '')}</div> */}
                      <select
                        value={selectedColumns[col] || "skip"}
                        onChange={(e) => handleColumnChange(col, e.target.value)}
                        className={styles.previewfilterDropdown}
                      >
                        {getAvailableOptions().map(option => (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>

                    </div>
                  </th>
                ))}
              </tr>
            </thead>

            <tbody style={{width: "100%"}}>
              {currentItems?.map((item, index) => (
                <tr key={item.id || index} className={styles.previewstripedRow}>
                  <td className={styles.previewtd}>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  {columnNames.map((col) => (
                    <td key={col} className={styles.previewtd}>
                      {col in item ? (item[col] || '-') : '-'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className={styles.sortedPagination}>
          <div className={styles.showingResults}>
            Showing: <span>{(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, data?.length)}</span> of {data?.length}
          </div>

          <div className={styles.pagination}>
            <button
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
              className={styles.paginationButton1}
            >
              <Paginationleft />
            </button>

            {pageNumbers.map((number) => (
              <button
                key={number}
                onClick={() => goToPage(number)}
                className={`${styles.paginationButton} ${number === currentPage ? styles.active : ""}`}
              >
                {number}
              </button>
            ))}

            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
              className={styles.paginationButton1}
            >
              <Paginationright />
            </button>
          </div>
        </div>

        <div className={styles.displayFlex}>
          <button className={styles.cancelBtn} onClick={() => navigate(-1)}>Back</button>
          <button
            className={styles.submitBtn}
            onClick={handleContinue}
            disabled={loading || Object.values(columnConflict).some(Boolean)}
          >
            {loading ? 'Processing...' : 'Continue'}
          </button>
        </div>
      </div>
    </>
  );
};

export default TableComponent;
